export default "__VITE_ASSET__BExkMjSL__"